import { defineMessages } from "react-intl";
import { BundleRestrictionType } from "./types";

export const messages = defineMessages({
  editPackage: {
    id: "bundle.edit",
    defaultMessage: "Edit package",
  },
  createPackage: {
    id: "bundle.create",
    defaultMessage: "Create package",
  },
  packageTicker: {
    id: "mealplan.ticker",
    defaultMessage: "Identificador",
  },
  active: {
    id: "default.active",
    defaultMessage: "active",
  },
  extras: {
    id: "package.extras",
    defaultMessage: "extras",
  },
  promotions: { id: "package.promotions", defaultMessage: "Promotions" },
  promoCodes: {
    id: "inventoryTable.CRU.codes",
    defaultMessage: "Promocodes",
  },
  bundleType: {
    id: "bundle.price.type",
    defaultMessage: "Bundle types",
  },
  bundleTypeFixed: { id: "bundle.type.fixed", defaultMessage: "Price per package" },
  bundleTypeDynamic: { id: "bundle.type.dynamic", defaultMessage: "Inventory line daily price" },
  bundleTypeOwn: { id: "bundle.type.own", defaultMessage: "Own" },
  packageFor: {
    id: "bundle.for",
    defaultMessage: "Package for:",
  },
  stayDates: {
    id: "inventoryTable.validitySection",
    defaultMessage: "Validity (travel window)",
  },
  bookingDates: {
    id: "package.bookingDates",
    defaultMessage: "Booking dates (booking window)",
  },
  addDatesRange: {
    id: "package.addDatesRange",
    defaultMessage: "Add range dates",
  },
  weekDay: {
    id: "package.weekDays",
    defaultMessage: "Week days",
  },
  startDate: {
    id: "package.startDate",
    defaultMessage: "Week days",
  },
  endDate: {
    id: "package.endDate",
    defaultMessage: "End date",
  },
  fileManager: {
    id: "accommodation.images",
    defaultMessage: "File manager",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
  presenceValidator: {
    id: "app.input.pressence",
    description: "ticker valdiation text",
    defaultMessage: "doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  tickerValdiation: {
    id: "app.ticker.validation",
    description: "ticker valdiation text",
    defaultMessage: "doesn't allow blank spaces and special characters except underscore ( _ )",
  },
  emtpySpacesValidator: {
    id: "app.input.emtpySpacesValidator",
    description: "empty spaces are not allowed",
    defaultMessage: "empty spaces are not allowed",
  },
  emptyImageValidator: {
    id: "app.required.images",
    description: "At least one image is mandatory to create the package",
    defaultMessage: "At least one image is mandatory to create the package",
  },
  errorSavingBundle: {
    id: "bundle.errorSavingBundle",
    defaultMessage: "Error saving bundle. Please try again or contact support.",
  },
  maxLengthTickerValidation: {
    id: "app.ticker.maxLength",
    description: "Maximum characters: 8",
    defaultMessage: "Maximum characters: 8",
  },
  moreThanZero: {
    id: "app.contractableConditions.moreThanZero",
    description: "Must be more than 0",
    defaultMessage: "Must be more than 0",
  },
  tabsErrors: {
    id: "app.form.someTabsErrors",
    description: "error tabs text",
    defaultMessage: "Some tabs have errors.",
  },
  properties: {
    id: "internalmenu.crmBeta.properties",
    description: "properties",
    defaultMessage: "properties",
  },
  images: {
    id: "bundle.images",
    description: "images",
    defaultMessage: "Images",
  },
  goBack: {
    id: "app.entityForm.goBack",
    description: "Go back to previous screen",
    defaultMessage: "Go back",
  },
  unlessOneExtraError: {
    id: "bundle.unless.oneExtra",
    description: "Unless one extra is necessary for creating a package",
    defaultMessage: "Unless one extra is necessary for creating a package",
  },
  unlessOneInventoryLineError: {
    id: "bundle.unless.oneInventoryLine",
    description: "Unless one inventory line is necessary for creating a package",
    defaultMessage: "Unless one inventory line is necessary for creating a package",
  },
  multiple: {
    id: "modification.translation.messages.multiple",
    description: "Multiple",
    defaultMessage: "Multiple",
  },
  propertiesTabValidator: {
    id: "bundle.errors.properties",
    description: "Check the red fields on the properties tab",
    defaultMessage: "Check the red fields on the properties tab",
  },
  imagesHelpText: {
    id: "app.imagesHelpText",
    description: "Images Help Text",
    defaultMessage:
      "Las imágenes deben tener una resolución 1900 x 1080 pixeles y un tamaño máximo de 10MB.",
  },
  minStay: {
    id: "bundle.minStay",
    defaultMessage: "Min. stay (days)",
  },
  maxStay: {
    id: "bundle.maxStay",
    defaultMessage: "Max. stay (days)",
  },
  minNotice: {
    id: "bundle.minNotice",
    defaultMessage: "Min. release (h)",
  },
  maxNotice: {
    id: "bundle.maxNotice",
    defaultMessage: "Max. release (h)",
  },
  closeToArrival: {
    id: "bundle.closeToArrival",
    defaultMessage: "CTA",
  },
  closeToDeparture: {
    id: "bundle.closeToDeparture",
    defaultMessage: "CTD",
  },
  restrictionTypeNone: {
    id: "bundle.restrictionTypeNone",
    defaultMessage: "No limit",
  },
  restrictionTypeConstant: {
    id: "bundle.restrictionTypeConstant",
    defaultMessage: "Constant",
  },
  restrictionTypeOwn: {
    id: "bundle.restrictionTypeOwn",
    defaultMessage: "Own",
  },
  restrictions: {
    id: "bundle.restrictions",
    defaultMessage: "Restrictions",
  },
  minValueValidator: {
    id: "bundle.minValueValidator",
    defaultMessage: "Must be equal or higher than {minValue}",
  },
});

export const BUNDLE_ALL_PRICE_TYPE_MESSAGE = {
  BUNDLE_TYPE_FIXED: { label: messages.bundleTypeFixed },
  BUNDLE_TYPE_OWN: { label: messages.bundleTypeOwn },
  BUNDLE_TYPE_DYNAMIC: { label: messages.bundleTypeDynamic },
};

export const BUNDLE_WITHOUT_OWN_PRICE_TYPE_MESSAGE = {
  BUNDLE_TYPE_FIXED: { label: messages.bundleTypeFixed },
  BUNDLE_TYPE_DYNAMIC: { label: messages.bundleTypeDynamic },
};

export const BUNDLE_RESTRICTION_TYPE_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  [BundleRestrictionType.NONE]: { label: messages.restrictionTypeNone },
  [BundleRestrictionType.CONSTANT]: { label: messages.restrictionTypeConstant },
  [BundleRestrictionType.OWN]: { label: messages.restrictionTypeOwn },
};

export const BUNDLE_RESTRICTION_TYPE_WITHOUT_CONSTANT_MESSAGE: {
  [key: string]: { label: { id: string; defaultMessage: string } };
} = {
  [BundleRestrictionType.NONE]: { label: messages.restrictionTypeNone },
  [BundleRestrictionType.OWN]: { label: messages.restrictionTypeOwn },
};
